import { useCallback, useRef, type MouseEvent, type PointerEvent } from 'react'

const DRAG_SLOP_PX = 4

interface RowDragGuard {
  onPointerDown: (event: PointerEvent) => void
  wasSelection: (event: MouseEvent) => boolean
}

/** Keeps selecting text inside an option row from changing its answer. */
export function useRowDragGuard(): RowDragGuard {
  const origin = useRef<{ x: number; y: number } | null>(null)
  const onPointerDown = useCallback((event: PointerEvent) => {
    origin.current = { x: event.clientX, y: event.clientY }
  }, [])
  const wasSelection = useCallback((event: MouseEvent) => {
    const start = origin.current
    origin.current = null
    if (event.detail === 0) return false
    if (event.detail > 1) return true
    if (!start) return false
    return Math.abs(event.clientX - start.x) > DRAG_SLOP_PX || Math.abs(event.clientY - start.y) > DRAG_SLOP_PX
  }, [])
  return { onPointerDown, wasSelection }
}
